import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF } from "@/components/SiteHeader";

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="bg-navy-950 py-10">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
        <p className="font-display text-xl font-extrabold text-white">
          QUADRA<span className="text-steel-400">CITI</span>
        </p>
        <a
          data-testid="footer-phone-link"
          href={PHONE_HREF}
          className="flex items-center gap-2 text-sm font-semibold text-navy-100 hover:text-white"
        >
          <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
        </a>
      </div>
      <p className="mt-6 text-xs leading-relaxed text-navy-300">
        © {new Date().getFullYear()} Quadraciti · quadraciti.com. Carlisle
        SynTec, Sure-Seal, Sure-White, Sure-Weld, Sure-Flex, FleeceBACK,
        InsulBase, and SecurShield are trademarks of Carlisle SynTec Systems.
        All other manufacturer names and trademarks are the property of their
        respective owners. Product information is provided by the respective
        manufacturers; contact us for current availability and pricing.
      </p>
    </div>
  </footer>
);
